import { ImageDocumentEnum } from '../../enums/image/image-document.enum';
import { ImageDamageEnum } from '../../enums/image/image-damage.enum';
import { ImagePanoramicEnum } from '../../enums/image/image-panoramic.enum';
import { ImageOtherEnum } from '../../enums/image/image-other.enum';
import { ImageBodyshopEnum } from '../../enums/image/image-bodyshop.enum';
export class SmartphotoImages {
    all = [];
    documents;
    damages;
    panoramic;
    others;
    withDamages;
    bodyshop;
    constructor(smartphotoImages) {
        this.all = smartphotoImages;
        this.withDamages = smartphotoImages.filter((image) => image.hasDamages);
        this.damages = this.filter(Object.values(ImageDamageEnum));
        this.documents = this.filter(Object.values(ImageDocumentEnum));
        this.others = this.filter(Object.values(ImageOtherEnum));
        this.panoramic = this.filter(Object.values(ImagePanoramicEnum));
        this.bodyshop = this.filter(Object.values(ImageBodyshopEnum));
    }
    static getZipName(numRef, type = '') {
        const pad = (value) => String(value).padStart(2, '0');
        const currentDate = new Date(Date.now());
        const date = `${pad(currentDate.getDay())}${pad(currentDate.getMonth() + 1)}${pad(currentDate.getFullYear())}`;
        const time = `${pad(currentDate.getHours())}${pad(currentDate.getMinutes() + 1)}${pad(currentDate.getSeconds())}`;
        return `${numRef}_${type}_${date}_${time}`;
    }
    filter(types) {
        return this.all.filter((image) => types.some((type) => image.type.startsWith(type)));
    }
    getImagesWithAlerts() {
        return this.all.filter((image) => image.alerts.length > 0);
    }
    getImagesWithDamagesAndAlerts() {
        return this.all.filter((image) => image.hasDamages && image.alerts.length > 0);
    }
}
